var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"modal"},[_c('div',{class:['modal__body', { 'modal__body--form': _vm.forForm }]},[_c('div',{staticClass:"modal__close",on:{"click":_vm.handleModalCloseClick}}),_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }